import React, { useState, useEffect } from "react";
import { useForm, FormProvider, useWatch } from "react-hook-form";
//Material
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
//Component
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
import FormInput from "../../stories/hook-controls/input";
import CheckboxModle from "../../stories/selection-control/checkbox/module";
import { Modal } from "../../stories/modal";
import { ReactTable } from "../../stories/react-table";
//Function
import { setDataToFormHookV2, isEmptyStr } from "../../utils/common-function";
import { getMaintenanceColumns } from "./columns/role-module-maintenance";
import { buildParameter } from "./parameter";
import * as alertDialog from "../../utils/alert";
import * as api from "./api";
import * as apiMaster from "./../master/api";

function RoleModuleMaintenance() {
  //Context

  //State
  const [openModal, setOpenModal] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [DataList, setDataList] = useState([]);
  const [DataDetail, setDataDetail] = useState({});

  //Event
  const onOpenAddModal = () => {
    setOpenModal(true);
    setEditMode(false);
    setDataDetail(null);
  };
  const onOpenEditModal = () => {
    setOpenModal(true);
    setEditMode(true);
  };
  const onCloseModal = () => {
    setOpenModal(false);
  };

  //Function
  const Edit = (Detail) => {
    onOpenEditModal();
    setDataDetail(Detail);
  };

  //--------
  const fetch = async () => {
    let res = await api.GetListRoleModuleMaster();
    setDataList(res);
  };
  useEffect(() => {
    fetch();
  }, []);

  return (
    <div>
      <BaseContainer maxWidth={false}>
        <BoxTemplate1
          height="80vh"
          title="Role-Module Maintenance"
          onClickAdd={onOpenAddModal} /*add*/
        >
          <ReactTable
            keyField="ROLE_ID"
            data={DataList}
            columns={getMaintenanceColumns(Edit)}
            
          />
        </BoxTemplate1>
        <DataModal
          editmode={editMode ? 1 : 0}
          open={openModal}
          onClose={onCloseModal}
          search={fetch}
          datadetail={DataDetail}
        />
      </BaseContainer>
    </div>
  );
}

function DataModal(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
  }));

  const { onClose } = props;
  const { open, editmode } = props;
  const { datadetail, search = () => {}, ...otherprops } = props;

  const method = useForm();
  const {
    setValue,
    getValues,
    setError,
    clearErrors,
    errors,
    control,
  } = method;
  const [ModuleData, setModuleData] = useState([]);

  //Effect
  useEffect(() => {
    (async () => {
      let data = await apiMaster.GetModuleMasterList();
      setModuleData(data);
    })();
  }, [setModuleData]);

  useEffect(() => {
    if (!open) return;
    if (editmode) {
      let data = setDataToFormHookV2(datadetail);
      setTimeout(
        () => data?.forEach(({ name, value }) => setValue(name, value)),
        100
      );
    }
  }, [datadetail, setValue, open, editmode]);

  const SaveDetail = async () => {

    const ID = editmode ? datadetail.ROLE_ID : null;
    let param = buildParameter.SaveDetail(ID, getValues(), ModuleData);
    let res = await api.SaveRoleModule(param);
    if (res) {
      search();
      onClose();
      alertDialog.inform_success();
    }
  };

  const classes = useStyles();

  return (
    <div>
      <Modal
        {...otherprops}
        onSave={SaveDetail}
        title={editmode ? "Edit Role Module" : "Add  Role Module"}
      >
        <FormProvider {...method}>
          <div className={classes.root}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box m={3} display="flex">
                  <FormInput
                    name="ROLE_ID"
                    label="Role ID"
                    InputProps={{
                      readOnly: true,
                    }}
                    variant="filled"
                    errorobj={errors}
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <CheckboxModle name="ListModule" />
              </Grid>
            </Grid>
          </div>
        </FormProvider>
      </Modal>
    </div>
  );
}
export default RoleModuleMaintenance;
